<template>
  <div>
    <div class="buttonContainer">
      <PlayButton :isPlaying="isPlaying" :play="play" :stop="stop" />
    </div>
  </div>
</template>

<script>
import SearchBox from './SearchBox';
import PlayButton from './PlayButton';

export default {
  name: 'MobileActions',
  components: {
    SearchBox,
    PlayButton
  },
  props: ['updateLocation', 'showLoading', 'play', 'stop', 'isPlaying']
}

</script>

<style lang="scss" scoped>
.buttonContainer {
  margin-left: 1em;
  position: absolute;
  left: 0;
  bottom: 0;
}
.searchContainer {
  box-sizing: border-box;
  margin-right: 1em;
  position: absolute;
  right: 0;
  bottom: 0;
}
.searchText {
  font-size: 18px;
  font-weight: bold;
  font-variant: all-small-caps;
  margin: 0 0 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/MobileActions.vue